var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"success",on:{"click":function($event){return _vm.openWhatsApp()}}},[_vm._v(" Precisa de ajuda? Fale com a syngoo clicando aqui! ")])}
var staticRenderFns = []

export { render, staticRenderFns }